// externals
import React from 'react';

// components
import { CheckIcon } from '../../icons/CheckIcon';
import {
    PackagesSectionTitle,
    HighlightsColumn,
    HighlightsTrimLabel,
    HighlightsHeaderRow,
    HighlightsGrid,
    HighlightItem
} from '../PackagesSection.style';

export const TrimHighlights: React.FC<{ trim?: string; highlights: string[] }> = ({ trim, highlights }) => (
    <HighlightsColumn>
        <HighlightsHeaderRow>
            <PackagesSectionTitle level={7} weight="semibold" forwardedAs="h3">
                Factory options added
            </PackagesSectionTitle>
            {trim && (
                <HighlightsTrimLabel data-testid="highlights-trim-label" size="xsmall" weight="semibold" forwardedAs="p">
                    Standard on {trim}
                </HighlightsTrimLabel>
            )}
        </HighlightsHeaderRow>
        <HighlightsGrid>
            {highlights.map((feature, index) => (
                <HighlightItem key={index} data-testid={`highlight-${index}`} size="small" weight="regular" forwardedAs="div">
                    <CheckIcon />
                    {feature}
                </HighlightItem>
            ))}
        </HighlightsGrid>
    </HighlightsColumn>
);
